module.exports = __webpack_public_path__ + "img/csgo-avatar-lg.ca941bea.png";